import React, { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "../routes/Routes";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Header from "../components/Header/Header";
import Menu from "../components/Menu/Menu";

const drawerWidth = 240;

const MainLayout = ({
	goToQR,
	setGoToQR,
	goToNavigation,
	setGoToNavigation,
	goToAppearance,
	setGoToAppearance,
	onboardingFinished,
	setOnboardingFinished,
	onboardingStarted,
	setOnboardingStarted,
	goToPages,
	setGoToPages,
	goToHome,
	setGoToHome,
	goToPublish,
	setGoToPublish,
	setRun,
}) => {
	const [mobileOpen, setMobileOpen] = useState(false);

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};

	return (
		<Box sx={{ display: "flex" }}>
			<CssBaseline />
			<BrowserRouter>
				<Header
					drawerWidth={drawerWidth}
					mobileOpen={mobileOpen}
					handleDrawerToggle={handleDrawerToggle}
					onboardingFinished={onboardingFinished}
				/>
				<Menu
					drawerWidth={drawerWidth}
					mobileOpen={mobileOpen}
					handleDrawerToggle={handleDrawerToggle}
				/>
				<Routes
					drawerWidth={drawerWidth * 2}
					goToQR={goToQR}
					setGoToQR={setGoToQR}
					goToNavigation={goToNavigation}
					setGoToNavigation={setGoToNavigation}
					goToAppearance={goToAppearance}
					setGoToAppearance={setGoToAppearance}
					onboardingFinished={onboardingFinished}
					setOnboardingFinished={setOnboardingFinished}
					goToPages={goToPages}
					setGoToPages={setGoToPages}
					goToHome={goToHome}
					setGoToHome={setGoToHome}
					goToPublish={goToPublish}
					setGoToPublish={setGoToPublish}
					onboardingStarted={onboardingStarted}
					setOnboardingStarted={setOnboardingStarted}
					setRun={setRun}
				/>
			</BrowserRouter>
		</Box>
	);
};

export default MainLayout;
